import ApiBase from './Api'
import { GetSourceListRequest, PostSourceRequest, SourceType } from '@finance-lab/utils/types'

type IssueFields = {
    statusStage: number
    statusComplete: 0 | 1
}

type NewSource = {
    prId: string
    issueId?: string
    convertibleId?: string
    warrantId?: string
    sourceType: SourceType
}

const SOURCE_API_PATHS = {
    SOURCES: '/sources',
    SOURCES_ADMIN: '/admin/sources',
}

class SourceApi extends ApiBase {
    async findByField(
        queryParameters: { prId: string; sourceUrl?: undefined } | { prId: undefined; sourceUrl: string },
    ) {
        const response = await this._getRequest<GetSourceListRequest>(SOURCE_API_PATHS.SOURCES, {
            queryParameters,
        })
        return response
    }

    async findByIssueId(issueId: string) {
        const response = await this._getRequest<GetSourceListRequest>(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { issueId },
        })
        return response
    }
    async findByWarrantId(warrantId: string) {
        const response = await this._getRequest<GetSourceListRequest>(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { warrantId },
        })
        return response
    }
    async findByConvertibleId(convertibleId: string) {
        const response = await this._getRequest<GetSourceListRequest>(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { convertibleId },
        })
        return response
    }
    async create(newSource: NewSource, issueFields?: IssueFields) {
        const response = await this._postRequest<PostSourceRequest>(SOURCE_API_PATHS.SOURCES_ADMIN, {
            ...newSource,
            issueFields,
        })
        return response
    }
}

export default SourceApi
